if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.openTab = this.openTab.bind(this);
      }

      getTabPanel(id) {
        if (!id) return null;

        return Array.from(this.querySelectorAll('.tabcontent')).find((item) => item.id === id) || null;
      }

      scrollTabIntoView(tab) {
        const tabList = tab.closest('.tab');
        if (!tabList || tabList.scrollWidth <= tabList.clientWidth) return;

        if (typeof tab.scrollIntoView === 'function') {
          tab.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
          return;
        }

        const nextLeft = tab.offsetLeft - (tabList.clientWidth - tab.offsetWidth) / 2;
        tabList.scrollTo({left: Math.max(0, nextLeft), behavior: 'smooth'});
      }

      openTab(e) {
        const id = e.currentTarget.getAttribute('data-id');
        const currentTab = this.getTabPanel(id);
        if (!currentTab) return;

        this.querySelectorAll(".tabcontent").forEach((item)=>{
          item.style.display = 'none';
        });
        this.querySelectorAll('.tablinks').forEach((item)=>{
          item.classList.remove('active');
        });

        // Show the current tab, and add an "active" class to the button that opened the tab
        currentTab.style.display = "block";
        e.currentTarget.classList.add('active');
        this.scrollTabIntoView(e.currentTarget);
      }
      connectedCallback() {
        this.querySelectorAll('.tablinks').forEach((item)=>item.addEventListener('click', this.openTab));
      }

      disconnectedCallback() {
        this.querySelectorAll('.tablinks').forEach((item)=>item.removeEventListener('click', this.openTab));
      }
    }
  );
}
